var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53846 0.5C3.84185 0.5 2.46154 1.91663 2.46154 3.65789C2.46154 5.39916 3.84185 6.81579 5.53846 6.81579C7.23508 6.81579 8.61539 5.39916 8.61539 3.65789C8.61539 1.91663 7.23508 0.5 5.53846 0.5ZM5.53846 5.55263C4.52062 5.55263 3.69231 4.70253 3.69231 3.65789C3.69231 2.61326 4.52062 1.76316 5.53846 1.76316C6.55631 1.76316 7.38462 2.61326 7.38462 3.65789C7.38462 4.70253 6.55631 5.55263 5.53846 5.55263ZM11.0769 12.5V11.8684C11.0769 9.43116 9.144 7.44737 6.76923 7.44737H4.30769C1.93231 7.44737 0 9.43116 0 11.8684V12.5H1.23077V11.8684C1.23077 10.1272 2.61108 8.71053 4.30769 8.71053H6.76923C8.46585 8.71053 9.84615 10.1272 9.84615 11.8684V12.5H11.0769Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.0036d0b074936f72d5ae45b2b9019e05.svg";
export { ForwardRef as ReactComponent };